module.exports = __webpack_public_path__ + "static/media/3.238350d6.jpeg";